import { FileBrowserGdt } from "components/FlyoutFiles/FlyoutFilesGDT";
import { useProjectDataContext } from "pages/project/ProjectDataProvider";

export const ProjectTabFiles = () => {
  const { project } = useProjectDataContext();
  // wraps in a div with height set so the file browser doesn't collapse
  // down to minimum height - especially important when no files in project
  return (
    <div style={{ display: "flex", minHeight: 300, height: "100%" }}>
      <FileBrowserGdt projectKey={project.key} />
    </div>
  );
};
